import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { ActivityIndicator as BaseIndicator } from 'exoflex';
import { ACTIVITY_INDICATOR } from '../constants/colors';

type Size = 'small' | 'medium' | 'large';

type Props = {
  style?: StyleProp<ViewStyle>;
  size?: Size;
  color?: string;
  animating?: boolean;
};

export default function ActivityIndicator(props: Props) {
  let {
    style,
    size = 'large' as Size,
    color = ACTIVITY_INDICATOR.default,
    animating = true,
  } = props;

  let sizeIndicator = size === 'medium' ? 35 : size;
  return (
    <View style={[styles.wrapper, style]}>
      <BaseIndicator size={sizeIndicator} color={color} animating={animating} />
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
